/**
 * @flow
 * @relayHash 0bee37480cd73b036647e1bade57515a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PortfolioTypes = "CART" | "FOLDER" | "HEART" | "PROCUREMENT" | "PROJECT" | "%future added value";
export type PortfoliosAction = "ADD" | "EDIT" | "REMOVE" | "REORDER" | "%future added value";
export type PrivacyType = "PRIVATE" | "PUBLIC" | "SHAREABLE" | "%future added value";
export type ModifyPortfoliosInput = {|
  action: PortfoliosAction,
  description?: ?string,
  endPortfolioId?: ?string,
  itemsIds?: ?$ReadOnlyArray<?string>,
  name?: ?string,
  note?: ?string,
  portfolioIds?: ?$ReadOnlyArray<?string>,
  portfoliosType: PortfolioTypes,
  privacyLevel?: ?PrivacyType,
  startPortfolioId?: ?string,
  targetPortfolioId?: ?string,
  userId: string,
  clientMutationId?: ?string,
|};
export type ModifyPortfolios_esMutationVariables = {|
  input: ModifyPortfoliosInput
|};
export type ModifyPortfolios_esMutationResponse = {|
  +modifyPortfolios: ?{|
    +portfolio: ?{|
      +id: string,
      +serviceId: ?string,
    |},
    +portfolios: ?$ReadOnlyArray<?{|
      +id: string
    |}>,
  |}
|};
export type ModifyPortfolios_esMutation = {|
  variables: ModifyPortfolios_esMutationVariables,
  response: ModifyPortfolios_esMutationResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ModifyPortfoliosInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "modifyPortfolios",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "ModifyPortfoliosInput!"
      }
    ],
    "concreteType": "ModifyPortfoliosPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "portfolio",
        "storageKey": null,
        "args": null,
        "concreteType": "PortfolioV2",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "portfolios",
        "storageKey": null,
        "args": null,
        "concreteType": "PortfolioV2",
        "plural": true,
        "selections": [
          (v1/*: any*/)
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ModifyPortfolios_esMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ModifyPortfolios_esMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "ModifyPortfolios_esMutation",
    "id": "app-buyer-misc/209.0.0-2019-03-26T14:04:46.491Z/ModifyPortfolios_esMutation",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0463c0ea7152430cffe365763ae5f0f8';
module.exports = node;
